'use client'

import { Maps } from 'maps/components/Maps/Maps'
import { StoreList } from 'maps/components/StoreList/StoreList'
import { StoreLocatorTitle } from 'maps/components/StoreLocator/StoreLocatorTitle/StoreLocatorTitle'
import { useMapState } from 'maps/hooks/useMapState/useMapState'
import { useRef } from 'react'

import styles from './StoreFinder.module.scss'

export const StoreFinder = () => {
	const ref = useRef<HTMLDivElement>(null)
	const { stores } = useMapState()

	return (
		<div ref={ref}>
			{stores && (
				<div className={styles.storeFinderContent}>
					<div className={styles.storeListContainer}>
						<StoreLocatorTitle />
						<StoreList showPhone showDisclaimer />
					</div>
					<Maps className={styles.map} />
				</div>
			)}
		</div>
	)
}
